module.exports = __webpack_public_path__ + "static/img/jiagong_b2(1).d463712.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jiagong_b2(1).jpg
// module id = fr2y
// module chunks = 1